import { format as formatBase } from "date-fns"
import { getLocale } from "./getLocale"

export function format(date: Date, formatStr: string) {
  return formatBase(date, formatStr, {
    locale: getLocale(),
  })
}
